import { render, staticRenderFns } from "./CustomerNps.vue?vue&type=template&id=1c4512d2&scoped=true"
import script from "./CustomerNps.vue?vue&type=script&lang=js"
export * from "./CustomerNps.vue?vue&type=script&lang=js"
import style0 from "./CustomerNps.vue?vue&type=style&index=0&id=1c4512d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4512d2",
  null
  
)

export default component.exports